import { useEffect } from 'react';
import { usePwa } from '../lib/pwa.js';
import { toast } from '../lib/toast-store.js';

/**
 * Bottom bar shown when a new app version is waiting. Tapping Reload activates
 * the new service worker and refreshes; "Later" dismisses until the next load.
 * Also surfaces a one-time "ready to work offline" toast on first install.
 */
export function UpdatePrompt() {
  const needRefresh = usePwa((s) => s.needRefresh);
  const offlineReady = usePwa((s) => s.offlineReady);
  const reload = usePwa((s) => s.reload);
  const dismiss = usePwa((s) => s.dismiss);
  const clearOfflineReady = usePwa((s) => s.clearOfflineReady);

  useEffect(() => {
    if (offlineReady) {
      toast('Ready to work offline');
      clearOfflineReady();
    }
  }, [offlineReady, clearOfflineReady]);

  if (!needRefresh) return null;

  return (
    <div className="update-bar" role="status">
      <span>A new version is available.</span>
      <div className="update-actions">
        <button type="button" className="update-later" onClick={dismiss}>
          Later
        </button>
        <button type="button" className="update-now" onClick={reload}>
          Reload
        </button>
      </div>
    </div>
  );
}
